/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LayoutFieldsResponseDto } from '../../models/layout-fields-response-dto';

export interface ClientManagementGetLayoutFieldsGet$Params {
  groupLayout?: string;
  layout_uuid?: string;
}

export function clientManagementGetLayoutFieldsGet(http: HttpClient, rootUrl: string, params?: ClientManagementGetLayoutFieldsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LayoutFieldsResponseDto>>> {
  const rb = new RequestBuilder(rootUrl, clientManagementGetLayoutFieldsGet.PATH, 'get');
  if (params) {
    rb.query('groupLayout', params.groupLayout, {});
    rb.query('layout_uuid', params.layout_uuid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<LayoutFieldsResponseDto>>;
    })
  );
}

clientManagementGetLayoutFieldsGet.PATH = '/ClientManagement/GetLayoutFields';
